let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6p14c"), load("ie88R"), load("FBIp4")]).then(() => parcelRequire('cHhL0'));